import { useEffect, useState } from 'react'
import { registro, mensagemDoErro } from '../services/api'
import { Card, Titulo, Botao, Etiqueta, Erro, Vazio } from '../components/ui'

/**
 * Quem mudou o quê, quando e por quê.
 *
 * Edição publicada nunca é alterada depois — é isso que torna esta lista
 * confiável quando alguém pergunta o que estava no ar na quinta-feira.
 *
 * "Voltar para" PREPARA um rascunho, não publica. Voltar atrás passa pelo mesmo
 * caminho de qualquer outra mudança: com autor, razão e uma versão nova. Seria
 * estranho que a única alteração sem ninguém confirmando fosse justamente a
 * feita às pressas, quando algo deu errado.
 */
export default function Historico() {
  const [linhas, setLinhas] = useState(null)
  const [erro, setErro] = useState('')
  const [aviso, setAviso] = useState('')

  useEffect(() => { carregar() }, [])

  async function carregar() {
    try {
      const c = await registro.console()
      setLinhas(c.historico)
    } catch (e) { setErro(mensagemDoErro(e)) }
  }

  async function voltar(version) {
    setErro(''); setAviso('')
    try {
      await registro.voltarPara(version)
      setAviso(`A v${version} foi copiada para o rascunho. Revise e publique para ela voltar ao ar.`)
    } catch (e) { setErro(mensagemDoErro(e)) }
  }

  const TOM = { published: 'ok', draft: 'aviso', superseded: 'neutro' }
  const ROTULO = { published: 'no ar', draft: 'rascunho', superseded: 'anterior' }

  if (!linhas) return <Vazio>carregando…</Vazio>

  return (
    <div className="flex flex-col gap-5">
      <Titulo sub="Voltar copia a edição escolhida para o rascunho — não publica sozinho.">
        Histórico
      </Titulo>

      {aviso && (
        <div className="rounded-lg border border-pinho-100 bg-pinho-50 p-3 text-sm text-pinho-700">{aviso}</div>
      )}
      <Erro>{erro}</Erro>

      <Card className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-zinc-200 bg-zinc-50 text-left text-[11px] uppercase tracking-wide text-zinc-500">
              <th className="p-3 font-semibold">Versão</th>
              <th className="p-3 font-semibold">Quando</th>
              <th className="p-3 font-semibold">Quem</th>
              <th className="p-3 font-semibold">Por quê</th>
              <th className="p-3 font-semibold" />
            </tr>
          </thead>
          <tbody>
            {linhas.map((e) => (
              <tr key={e.version} className="border-b border-zinc-100 last:border-0">
                <td className="p-3">
                  <span className="font-mono text-xs font-bold">v{e.version}</span>{' '}
                  <Etiqueta tom={TOM[e.status]}>{ROTULO[e.status]}</Etiqueta>
                </td>
                <td className="p-3 text-xs text-zinc-500">
                  {new Date(e.publishedAt ?? e.createdAt).toLocaleString('pt-BR')}
                </td>
                <td className="p-3 text-xs text-zinc-600">{e.publishedBy ?? e.createdBy}</td>
                <td className="max-w-[46ch] p-3 text-xs text-zinc-600">{e.reason ?? '—'}</td>
                <td className="p-3">
                  {e.status === 'superseded' && (
                    <Botao variante="secundario" onClick={() => voltar(e.version)}>
                      Voltar para esta
                    </Botao>
                  )}
                </td>
              </tr>
            ))}
            {linhas.length === 0 && (
              <tr><td colSpan={5}><Vazio>Nenhuma edição ainda.</Vazio></td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  )
}
